import { render, staticRenderFns } from "./BaseFormControl.vue?vue&type=template&id=131cfe54&"
import script from "./BaseFormControl.vue?vue&type=script&lang=js&"
export * from "./BaseFormControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports